import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText,
  MDBCheckbox


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';



function EditarResponsavel() {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState([]);
  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/responsavel')
  const {cpf} = useParams();
  const [formValue, setFormValue] = useState({
    nomeResponsavel:'',
    cpf: '',
    idEscola: userLogin.idescola,
    login: '',
    senha: ''
  });

  const [checked, setChecked] = useState(false);

  const handleSubmit = async (values) => {
    values.preventDefault();
    util.isSubmitting()
    const result = await api.atualizarResponsavelApi(formValue);
    result ? toast.success("Atualizado com sucesso!") && navigate("/area-responsavel") : null;
    util.isSubmitting()
    
  }

  const handleDelet = async () => {
    const object = {
        cpf: cpf
    }
    util.isSubmitting()
    const result = await api.excluirResponsavelApi(object);
    result ? toast.success("Excluido com sucesso!") && navigate("/area-responsavel") : null;
    util.isSubmitting()
    
  }

  useEffect(() => {
    const getResponsavel = async () => {
      try {
        const object = {
          cpf: cpf,
        };
        const response = await api.pegarResponsavelApi(object);
        const data = await response;
        setUsuario(data[0]);
        
        setFormValue({
          nomeResponsavel:data[0].nomeres,
          cpf: data[0].cpf,
          idEscola: userLogin.idescola,
          login: data[0].login,
          senha: data[0].senha
        });
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };

    getResponsavel();
  }, [cpf]);

  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
       minHeight:'500',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column my-5 align-items-center'>

          <MDBCard className='bg-dark text-white w-50' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-5'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={!checked ? handleSubmit : handleDelet}>
                  <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'40%'}} feedback='Por favor digite o nome do responsavel!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='Nome do responsavel' id='formControNomeResponsavel' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='nomeResponsavel'
                          value={formValue.nomeResponsavel || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'40%', opacity: 0.4}} feedback='Por favor digite o CPF!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='CPF' id='formControCPF' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='cpf'
                          value={formValue.cpf || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          minLength={3}
                          disabled={true}
                          
                          />
                        
                      </MDBValidationItem>

                      </div>
                    <MDBValidationItem feedback='Por favor digite o login!' style={{opacity:0.4}} invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        className='bg-dark'
                        labelClass='text-white' 
                        label='Login' 
                        name='login'
                        id='formControLogin' 
                        type='text' 
                        size="lg"
                        value={formValue.login || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        disabled={true}
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                    <MDBValidationItem feedback='Por favor digite a senha!' invalid>
                      <MDBInput 
                        wrapperClass='mb-3 w-100' 
                        labelClass='text-white' 
                        label='Senha' 
                        name='senha'
                        id='formControSenha' 
                        type='password' 
                        size="lg"
                        value={formValue.senha || ''}
                        onChange={onChange}
                        onBlur={onBlur} 
                        required
                        style={{color:"white"}}/>
                    </MDBValidationItem >
                   
                    
                    
                    <div className='my-2'>
                        <MDBCheckbox

                            id='controlledCheckbox'
                            label='Habilitar botão "Exluir"'
                            checked={checked}
                            onChange={() => setChecked(!checked)}
                        />
                    </div>
                    <div className='d-flex justify-content-between align-items-center flex-column'>
                        <MDBBtn 
                            outline 
                            className='my-3 btn-home w-100' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={!checked}                 
                            >
                            
                            excluir
                        </MDBBtn>
                        <MDBBtn 
                            outline 
                            className='px-5 w-100 btn-home' 
                            color='white' 
                            size='lg'
                            type='submit'   
                            id='submitForm'  
                            disabled={false}                 
                            >
                            
                            Editar
                        </MDBBtn>
                      </div>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/listar-responsavel")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default EditarResponsavel;